import { PricingTraditional } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Тарифы и промокоды (БО-21, Приложение D «тарифы и промокоды»): конструктор тарифа с версиями (ПОРТ-30),
 * промокоды и условия пилотов (ПОРТ-35), партнёрская программа под флагом (ПОРТ-36), настройки биллинга
 * (НДС, пробный период и бесплатный уровень ПОРТ-31, неоплата ПОРТ-34). Чтение — DODOC_SUPPORT, изменения — DODOC_ADMIN.
 */
export const section = defineSection({
  id: 'backoffice.tariffs',
  area: 'backoffice',
  path: 'tariffs/*',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT'],
  icon: PricingTraditional,
  titleKey: 'tariffs:title',
  namespaces: ['backoffice', 'billing', 'finance'],
  navGroup: 'finance',
  order: 100,
  load: () => import('./TariffsPage'),
});
